import { Check } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import PriceTable from "@/components/PriceTable";
import CTASection from "@/components/CTASection";
import ZWImage from "@/components/ZWImage";
import { WINTER_ROWS, WINTER_UMFANG, HINWEISE } from "@/data/services";

export default function Winterdienst() {
  return (
    <>
      <SEO
        title="Winterdienst Herten – Schneeräumung & Saisonverträge | ZWILLINGSWERK"
        description="Winterdienst in Herten + 20 km: Einsatz ab 49 €, Streudienst 15 €, Saisonvertrag EFH ab 350 € / MFH ab 600 €, Gewerbe-Flächenpreis 0,80–2,50 €/m². Zuverlässig & pünktlich."
      />
      <PageHero
        eyebrow="Winterdienst · Privat & Gewerbe"
        title="Sicher durch die kalte Jahreszeit."
        description="Wir sorgen für sichere Wege, Einfahrten und Flächen – zuverlässig, flexibel und pünktlich. Egal ob privat oder gewerblich."
        testid="winter-hero"
      />

      <section className="py-14 bg-[#F8FAF8] border-b border-[#D7E5D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-8 space-y-8">
              <PriceTable
                title="Winterdienst & Saisonverträge"
                subtitle="Räumen, Streuen, Kontrollen – Einzeleinsatz oder ganze Saison"
                badge="Saison & Einsatz"
                rows={WINTER_ROWS}
                footnote="Saisonvertrag = sorgenfreier Winter ohne Einzelabrechnung. Anfahrt 20 km inklusive."
                testid="price-table-winter"
              />

              <div className="bg-white rounded-xl border border-[#D7E5D9] p-6" data-testid="winter-umfang">
                <h2 className="text-xl font-black text-[#122B18] font-display mb-4">
                  Unsere Leistungen im Winterdienst
                </h2>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 text-sm text-[#3A523E]">
                  {WINTER_UMFANG.map((u) => (
                    <li key={u} className="flex items-start gap-2">
                      <Check className="w-4 h-4 text-[#1E5631] shrink-0 mt-0.5" /> {u}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <aside className="lg:col-span-4 space-y-6">
              <ZWImage
                src="/images/winterdienst.png"
                fallback="https://images.unsplash.com/photo-1517299321609-52687d1bc55a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Schneeräumung auf einem Gehweg in Herten durch den ZWILLINGSWERK Winterdienst"
                className="w-full aspect-[4/3] rounded-2xl shadow-lg"
                subcaption="Winterdienst"
                caption="Freie Wege, bevor der Tag beginnt"
                testid="winter-image"
              />

              <div className="bg-[#122B18] text-white rounded-2xl p-6 space-y-4">
                <h2 className="text-lg font-black font-display">Für Hausverwaltungen & Gewerbe</h2>
                <p className="text-sm text-[#D7E5D9] leading-relaxed">
                  Flächenpreise nach Objektgröße: 0,80–2,50 € netto pro m². Saisonvertrag Mehrfamilienhaus ab 600 €
                  netto – inklusive Streudienst und Sicherheitskontrollen.
                </p>
              </div>

              <div className="bg-white border border-[#D7E5D9] rounded-2xl p-6 space-y-3 text-xs text-[#4A634E]">
                <h2 className="text-sm font-bold text-[#122B18] uppercase tracking-wider">Wichtige Hinweise</h2>
                <p>{HINWEISE.mindest}</p>
                <p>{HINWEISE.anfahrt}</p>
                <p>{HINWEISE.zahlung}</p>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
